import React from 'react'

import ListFriendInvite from './ListFriendInvite'

class FriendSearchResults extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let resultsList = ''

    if (this.props.results !== undefined) {
      if (this.props.results.length > 0) {
        let resultsListItems = ''
        resultsListItems = this.props.results.map(item => (
          <ListFriendInvite
            device={this.props.device}
            key={item.id}
            aid={this.props.aid}
            fid={item.id}
            name={item.name}
            avatarUrl={item.avatarUrl}
            sendInternalInvite={this.props.sendInternalInvite}
          />
        ))
        resultsList = <ul className="friends-list">{resultsListItems}</ul>
      } else {
        resultsList = (
          <div className="warning text-center">
            There were no results for your search. Please try again or use the
            form below to invite someone to Cook'n!
          </div>
        )
      }
    }

    return <div>{resultsList}</div>
  }
}

export default FriendSearchResults



// WEBPACK FOOTER //
// ./src/Components/FriendSearchResults.js